import { setSearchText as filtersSearchText } from "components/common/Filters/Filters.slice";
import { filterPage } from "components/common/Filters/FiltersHelper";
import Basictabs from "components/common/Tabs";
import {
  setSearchText as AbovePropertySearchText,
  clearFilter
} from "components/features/AboveProperty/AboveProperty.slice";
import { useDispatch } from "react-redux";
import { useAppSelector } from "redux/hooks";
import PropertyPlans from "./PropertyPlans";
import ReviewPlanAssignments from "./ReviewPlanAssignments";
import TemplatePlans from "./TemplatePlans";

interface AbovePropertyListInterface {
  setSelectedTab: (tab: number) => void;
}

function AbovePropertyList(props: AbovePropertyListInterface) {
  const dispatch = useDispatch();
  const isAbovePropertyUser = useAppSelector((state) => state.app.loggedInUserDetails.isAbovePropertyUser);
  return (
    <>
      <Basictabs
        isParentTab
        tabDetails={[
          {
            label: "Property Plans",
            content: PropertyPlans,
            filtersToClear: [filterPage.inncodePlansDisplay, filterPage.consultantInncodePlansDisplay],
            searchTextClear: true
          },
          {
            label: "Template Plans",
            content: TemplatePlans,
            searchTextClear: true
          },
          ...(isAbovePropertyUser
            ? [
                {
                  label: "Review Plan Assignments",
                  content: ReviewPlanAssignments,
                  filtersToClear: [filterPage.orphanedPlansView],
                  searchTextClear: true
                }
              ]
            : [])
        ]}
        alignItems="left"
        marginBottom="0"
        onTabChangeFn={(value: any) => {
          props?.setSelectedTab(value);
          dispatch(filtersSearchText(""));
          dispatch(
            AbovePropertySearchText({
              inputText: "",
              searchType: "templatePlans",
              filterName: "searchText",
              parentView: "myPlans"
            })
          );
          dispatch(clearFilter({ parentView: "myPlans", filterType: "templatePlans" }));
        }}
      />
    </>
  );
}

export default AbovePropertyList;
